import btnStyle from '@/components/Shares/Button.module.css';
import classes from '@/components/Shares/Input.module.css';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Button, Input, Stack, Text, rem } from '@mantine/core';
import { AuthModalLayout } from './AuthModalLayout';
export const ConfirmPasswordModal: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <AuthModalLayout opened={false} handleClose={() => {}}>
      <Stack gap={10} mx="auto" align="center" w={{
      base: '100%',
      sm: 524,
      lg: 427
    }} pb={{
      base: 268,
      md: 370,
      lg: 254
    }}>
        <Text ta="center" c="var(--text-prime)" className={gunterzBold.className} fz={{
        base: 21,
        sm: 36,
        lg: 25
      }} lh={{
        base: rem(21),
        sm: rem(36),
        lg: rem(25)
      }}>
          {i18n._('almost there!')}
        </Text>

        <Text fz="xs" fw={700} ta="center" tt="uppercase" c="var(--text-dark)" w={{
        sm: 428,
        lg: 363
      }}>
          {i18n._('set your new password and unlock your primeroll adventure once again.')}
        </Text>

        <form style={{
        width: '100%'
      }}>
          <Stack w="100%" mt={22}>
            <Input placeholder={i18n._('New password')} classNames={{
            input: classes.input_style_2
          }} />
            <Input placeholder={i18n._('Confirm password')} classNames={{
            input: classes.input_style_2
          }} />
          </Stack>
        </form>

        <Button h={40} mt={22} fz="xs" type="submit" classNames={btnStyle}>
          {i18n._('update password')}
        </Button>
      </Stack>
    </AuthModalLayout>;
};